module.exports = __webpack_public_path__ + "fonts/Arial Narrow.b209ea8a.ttf";